import BasePage from "components/basePage/BasePage";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { showToast } from "services/helper";
import { getUserDescriptor } from "services/requests";
import { StandardForm } from "wm-standard-crud";

export default function UserForm() {
  const [descriptor, setDescriptor] = useState({});
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    getUserDescriptor().then((description) => setDescriptor(description));
  }, []);

  return (
    <BasePage title="Usuário">
      <StandardForm
        descriptor={descriptor}
        id={parseInt(id)}
        onSave={() => {
          showToast(
            `Usuário  ${id?.length > 0 ? "editado" : "criado"} com sucesso.`,
            "success"
          );
          navigate(-1); //It goes back to earlier page
        }}
        onError={() =>
          showToast(
            "Não foi possível realizar esta ação, tente novamente mais tarde.",
            "error"
          )
        }
      />
    </BasePage>
  );
}
